/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Documents_Pdf_LateInputs */

const en_queue_documents_pdf_late = /** @type {(inputs: Queue_Documents_Pdf_LateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents with a late PDF`)
};

/**
* | output |
* | --- |
* | "Documents with a late PDF" |
*
* @param {Queue_Documents_Pdf_LateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_documents_pdf_late = /** @type {((inputs?: Queue_Documents_Pdf_LateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Documents_Pdf_LateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_documents_pdf_late(inputs)
});